<template>
  <v-container fluid>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Novo produto
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formProduto">
          <v-tabs
            next-icon="chevron_right"
            prev-icon="chevron_left"
            show-arrows
            class="ui-tabs"
            v-model="tabs">
            <v-tab>
              <v-icon>info</v-icon> Dados do produto
            </v-tab>
            <v-tab v-if="$root.Permissions.distributor()">
              <v-icon>request_quote</v-icon> Tabela de preços
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs" class="ui-tabs-inherit mb-2">
            <v-tab-item class="px-1 pb-1">
              <v-card class="px-3">
                <v-row class="mt-0">
                  <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pb-0">
                    <v-text-field
                      v-model="produto.pro_nome"
                      label="Nome*"
                      :rules="[rules.required]"
                      autofocus
                      outlined
                      :disabled="salvando"
                      :loading="salvando"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pb-0">
                    <v-text-field
                      v-model="produto.pro_referencia"
                      label="Referência"
                      outlined
                      :disabled="salvando"
                      :loading="salvando"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-autocomplete
                      v-model="produto.uuid_cat_id"
                      autocomplete="off"
                      :items="categorias"
                      :rules="[rules.required]"
                      :loading="salvando"
                      :disabled="salvando"
                      @change="() => {
                        setaCategoria()
                        validaGetGenericos()
                      }"
                      label="Categoria*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0" v-if="!$root.Permissions.admin()">
                    <v-autocomplete
                      v-model="produto.uuid_pro_id_fk"
                      autocomplete="off"
                      :items="produtosGenericos"
                      :rules="[rules.required]"
                      :loading="salvando || loadingGenericos"
                      :disabled="salvando || loadingGenericos"
                      @change="(item) => completaDadosProduto(item)"
                      label="Produto base*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-autocomplete
                      v-model="produto.uuid_mar_id"
                      autocomplete="off"
                      :items="marcas"
                      :rules="[rules.required]"
                      :loading="salvando || loadingMarcas"
                      :disabled="salvando || loadingMarcas"
                      label="Marcas*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                    <v-autocomplete
                      v-model="produto.uuid_mod_id"
                      autocomplete="off"
                      :items="modelos"
                      :rules="[rules.required]"
                      :loading="salvando || loadingModelos"
                      :disabled="salvando || loadingModelos"
                      label="Modelos*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                    <v-textarea
                      outlined
                      rows="3"
                      v-model="produto.pro_descricao"
                      :loading="salvando"
                      :disabled="salvando"
                      label="Descrição"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0" v-if="categoriaSelecionada.cat_id !== '' && categoriaSelecionada.cat_id !== 3 && categoriaSelecionada.cat_id !== 5">
                    <v-autocomplete
                      v-model="produto.pro_entrada_padrao"
                      autocomplete="off"
                      :items="padroes"
                      :loading="salvando"
                      :disabled="salvando"
                      :rules="[rules.required]"
                      label="Padrão de entrada*"
                      append-icon="expand_more"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0" v-if="!$root.Permissions.admin() || $root.Permissions.admin() && this.$route.name != 'Produtos'">
                    <vuetify-money
                      lazy-validation
                      v-model="produto.pro_preco_custo"
                      :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                      :disabled="salvando"
                      :loading="salvando"
                      outlined
                      :options="optionsMoney"
                      valueWhenIsEmpty="0,00"
                      :rules="[rules.required]"
                      label="Preço de custo*"
                    ></vuetify-money>
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0" v-if="!$root.Permissions.admin() || $root.Permissions.admin() && this.$route.name != 'Produtos'">
                    <vuetify-money
                      lazy-validation
                      v-model="produto.pro_preco_venda"
                      :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                      :disabled="salvando"
                      :loading="salvando"
                      outlined
                      :options="optionsMoney"
                      valueWhenIsEmpty="0,00"
                      :rules="[rules.required]"
                      label="Preço de venda*"
                    ></vuetify-money>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
                    <v-divider class="mt-0 mb-5"></v-divider>
                    <v-row class="my-1" v-if="categoriaSelecionada.cat_id === 1">
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Potência (kWp)*"
                          outlined
                          v-model="produto.modulo.prm_potencia"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Peso (KG)*"
                          outlined
                          v-model="produto.modulo.prm_peso"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Área (m²)*"
                          outlined
                          v-model="produto.modulo.prm_area"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                    </v-row>
                    <v-row class="my-1" v-if="categoriaSelecionada.cat_id === 2">
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Potência (kWp)*"
                          outlined
                          v-model="produto.inversor.pri_potencia"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0" v-if="$root.Permissions.admin()">
                        <v-text-field-percent
                          label="Peso (KG)*"
                          outlined
                          v-model="produto.inversor.pri_peso"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                    </v-row>
                    <v-row class="my-1" v-if="categoriaSelecionada.cat_id === 3">
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Tensão corrente contínua máxima (kV)*"
                          outlined
                          v-model="produto.cabo.prc_tensao_cc_maxima"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Tensão corrente alternada máxima (kV)*"
                          outlined
                          v-model="produto.cabo.prc_tensao_ca_maxima"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Peso (KG)*"
                          outlined
                          v-model="produto.cabo.prc_peso"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Seção (mm²)*"
                          outlined
                          v-model="produto.cabo.prc_secao"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Diâmetro (mm)*"
                          outlined
                          v-model="produto.cabo.prc_diametro"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Comprimento (m)*"
                          outlined
                          v-model="produto.cabo.prc_comprimento"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                    </v-row>
                    <v-row class="my-1" v-if="categoriaSelecionada.cat_id === 4">
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Tensão normal (V)*"
                          outlined
                          v-model="produto.stringbox.prs_tensao_normal"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Tensão máxima (VCC)*"
                          outlined
                          v-model="produto.stringbox.prs_tensao_maxima"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Corrente (A)*"
                          outlined
                          v-model="produto.stringbox.prs_corrente"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Nível de proteção (kV)*"
                          outlined
                          v-model="produto.stringbox.prs_nivel_protecao"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Altura (m)*"
                          outlined
                          v-model="produto.stringbox.prs_altura"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Largura (m)*"
                          outlined
                          v-model="produto.stringbox.prs_largura"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Profundidade (m)"
                          outlined
                          v-model="produto.stringbox.prs_profundidade"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                    </v-row>
                    <v-row class="my-1" v-if="categoriaSelecionada.cat_id === 5">
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                        <v-autocomplete
                          v-model="produto.estrutura.uuid_tie_id"
                          autocomplete="off"
                          :items="tiposEstrutura"
                          :rules="[rules.required]"
                          :loading="salvando"
                          :disabled="salvando"
                          label="Tipo de estrutura*"
                          append-icon="expand_more"
                          outlined
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0" v-if="$root.Permissions.admin()">
                        <v-autocomplete
                          v-model="produto.estrutura.pre_orientacao"
                          autocomplete="off"
                          :items="orientacoes"
                          :rules="[rules.required]"
                          :loading="salvando"
                          :disabled="salvando"
                          label="Orientação*"
                          append-icon="expand_more"
                          outlined
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0" v-if="$root.Permissions.admin()">
                        <v-text-field
                          v-model="produto.estrutura.pre_fileiras"
                          label="Fileiras*"
                          type="number"
                          :rules="[rules.required]"
                          outlined
                          :disabled="salvando"
                          :loading="salvando"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0" v-if="$root.Permissions.admin()">
                        <v-text-field
                          v-model="produto.estrutura.pre_modulos"
                          label="Módulos*"
                          type="number"
                          :rules="[rules.required]"
                          outlined
                          :disabled="salvando"
                          :loading="salvando"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="my-1" v-if="categoriaSelecionada.cat_id === 6">
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Potência (KVA)*"
                          outlined
                          v-model="produto.transformador.prt_potencia"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Potência máxima (KVA)*"
                          outlined
                          v-model="produto.transformador.prt_potencia_maxima"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Altura (m)*"
                          outlined
                          v-model="produto.transformador.prt_altura"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          label="Largura (m)*"
                          outlined
                          v-model="produto.transformador.prt_largura"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando,
                            rules: [rules.required]
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Profundidade (m)*"
                          outlined
                          v-model="produto.transformador.prt_profundidade"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pt-0 pb-0">
                        <v-text-field-percent
                          :rules="[rules.required]"
                          label="Peso (KG)*"
                          outlined
                          v-model="produto.transformador.prt_peso"
                          v-bind:properties="{
                            readonly: false,
                            outlined: true,
                            disabled: salvando,
                            loading: salvando
                          }"
                          v-bind:options="{
                            locale: 'pt-BR',
                            length: 12,
                            precision: 2,
                            empty: 0,
                          }"
                        ></v-text-field-percent>
                      </v-col>
                    </v-row>
                    <v-row class="my-1" v-if="categoriaSelecionada.cat_id === 7">
                      <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0">
                        <v-autocomplete
                          v-model="produto.pro_unidade"
                          autocomplete="off"
                          :items="unidadeMedida"
                          :rules="[rules.required]"
                          :loading="salvando"
                          :disabled="salvando"
                          label="Unidade de medida*"
                          append-icon="expand_more"
                          outlined
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0"
                    v-if="this.$route.name != 'Orcamentos' &&
                    !this.$route.name != 'OportunidadeInterna'"
                  >
                    <v-file-input
                      show-size
                      clearable
                      ref="file"
                      v-model="produto.pro_imagem"
                      prepend-icon="image"
                      label="Adicionar imagem"
                      clear-icon="close"
                      truncate-length="50"
                      :loading="salvando"
                      :disabled="salvando"
                      v-if="isObject(produto.pro_imagem)"
                      :rules="[rules.size]"
                      hint="Tamanho recomendado: 300x300px"
                      persistent-hint
                      outlined
                    ></v-file-input>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="produto.pro_imagem && !isObject(produto.pro_imagem)">
                    <v-row no-gutters justify="start" align="center">
                      <div v-if="produto.pro_imagem">
                        <img alt="Imagem do produto" :src="produto.pro_imagem" class="produto_imagem">
                      </div>
                      <div>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                          </template>
                          <span>Remover imagem</span>
                        </v-tooltip>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item class="px-1 pb-1">
              <v-data-table
                :headers="headers"
                :items="precos"
                :search="search"
                multi-sort
                class="elevation-1 base_table"
                :footer-props="{
                  itemsPerPageOptions: [5,10,15,20,25,50,100],
                  showFirstLastPage: true,
                }"
                :header-props="{
                  sortIcon: 'north',
                }"
              >
                <template v-slot:top>
                  <v-row no-gutters align="center" justify="space-between">
                    <v-row class="py-2" justify="space-between" no-gutters>
                      <v-col cols="4">
                        <v-text-field
                          clearable
                          hide-details=""
                          clear-icon="close"
                          v-model="search"
                          outlined
                          label="Busca"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-btn
                          type="button"
                          color="primary"
                          @click="abrirDialogPreco()"
                        >
                          Adicionar novo preço
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-row>
                </template>
                <template v-slot:item.actions="{ item, index }">
                  <v-row no-gutters align="center" justify="center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" @click="abrirDialogExcluirPreco(index)" color="primary" class="ml-2">
                          delete
                        </v-icon>
                      </template>
                      <span>Remover</span>
                    </v-tooltip>
                  </v-row>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="fakeCadastro ? fakeSalvar() : salvarProduto()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPreco"
      persistent
      max-width="800px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Novo preço
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="fechaDialogPreco()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formProdutoPreco">
          <v-row class="mt-0 px-3">
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                v-model="preco.uuid_int_id"
                autocomplete="off"
                :items="listaIntegradoresDisponiveis()"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                label="Integrador*"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                v-model="preco.prp_acao"
                autocomplete="off"
                :items="modelosPreco"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                label="Modelo de precificação*"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0 pb-0" v-if="preco.prp_acao === 1 || preco.prp_acao === 2">
              <v-autocomplete
                v-model="preco.prp_tipo"
                autocomplete="off"
                :items="tiposPreco"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                label="Tipo preço*"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="mb-2 pt-0" v-if="preco.prp_tipo === 1">
              <v-text-field-percent
                :rules="[rules.required]"
                label="Valor*"
                outlined
                v-model="preco.prp_valor"
                v-bind:properties="{
                  readonly: false,
                  outlined: true,
                  suffix: '(%)',
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 12,
                  precision: 2,
                  empty: 0,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pt-0" v-else>
              <vuetify-money
                lazy-validation
                v-model="preco.prp_valor"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :disabled="salvando"
                :loading="salvando"
                outlined
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                :rules="[rules.required]"
                label="Preço*"
              ></vuetify-money>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="addNovoPreco()"
              :loading="salvandoPreco"
              :disabled="salvandoPreco"
            >
              Adicionar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogExcluirPreco"
      max-width="400"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover variação de preço
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelarExcluirPreco()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover está variação de preço?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            @click="cancelarExcluirPreco()"
            :loading="salvando"
            :disabled="salvando"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removerPreco()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover a imagem do produto?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
// import moment from 'moment'
// import axios from 'axios'
export default {
  props: ['abrir_dialog', 'produto_selecionado', 'produto_sem_cadastro'],
  data () {
    return {
      rules: {
        required: value => !!value || 'Obrigatório.',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      tabs: 0,
      salvando: false,
      dialog: false,
      dialogPreco: false,
      dialogExcluirPreco: false,
      search: '',
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 10,
        precision: 2
      },
      integradores: [],
      modelosPreco: [
        {
          text: 'Acréscimo',
          value: 1
        },
        {
          text: 'Desconto',
          value: 2
        },
        {
          text: 'Valor',
          value: 3
        }
      ],
      tiposPreco: [
        {
          text: 'Porcentagem',
          value: 1
        },
        {
          text: 'Valor',
          value: 2
        }
      ],
      categorias: [],
      loadingCategorias: false,
      orientacoes: [
        {
          text: 'Retrato',
          value: 1
        },
        {
          text: 'Paisagem',
          value: 2
        }
      ],
      unidadeMedida: [
        {
          text: 'KG',
          value: 1
        },
        {
          text: 'UN',
          value: 2
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      categoriaSelecionada: {
        cat_id: null
      },
      produto: {
        pro_nome: '',
        pro_descricao: '',
        pro_preco_custo: '',
        pro_preco_venda: '',
        pro_categoria: '',
        pro_entrada_padrao: '',
        pro_unidade: '',
        pro_imagem: null,
        precos: [],
        modulo: {},
        inversor: {},
        estrutura: {},
        transformador: {},
        stringbox: {},
        cabo: {}
      },
      precos: [],
      preco: {
        uuid_int_id: null,
        prp_acao: null,
        prp_tipo: null,
        prp_valor: null
      },
      indexPrecoExcluir: null,
      salvandoPreco: false,
      tiposEstrutura: [],
      marcas: [],
      modelos: [],
      loadingMarcas: false,
      loadingModelos: false,
      headers: [
        { text: 'Integrador', value: 'int_nome' },
        { text: 'Modelo de precificação', value: 'prp_acao' },
        { text: 'Tipo de preço', value: 'prp_tipo' },
        { text: 'Valor', value: 'prp_valor' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      fakeCadastro: false,
      loadingGenericos: false,
      produtosGenericos: [],
      produtosGenericosAll: [],
      dialogDeletarImagem: false
    }
  },
  watch: {
    abrir_dialog () {
      this.dialog = !this.dialog
      if (this.produto_sem_cadastro) {
        this.fakeCadastro = true
      } else {
        this.fakeCadastro = false
      }
    },
    produto_selecionado () {
      this.produto = this.produto_selecionado
      if (this.produto.pro_categoria) {
        this.produto.uuid_cat_id = this.produto.categoria.uuid_cat_id
        this.categoriaSelecionada = this.produto.categoria
        this.validaGetGenericos()
      }
      this.atualizaListagemPreco()
    }
  },
  methods: {
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    closeDialog () {
      this.produto = {
        pro_nome: '',
        pro_descricao: '',
        pro_preco_custo: '',
        pro_preco_venda: '',
        pro_categoria: '',
        pro_entrada_padrao: '',
        pro_unidade: '',
        precos: [],
        modulo: {},
        inversor: {},
        estrutura: {},
        transformador: {},
        stringbox: {},
        cabo: {}
      }
      if (this.$refs.formProduto) {
        this.$refs.formProduto.resetValidation()
      }
      this.$emit('cancelar-close')
    },
    abrirDialogPreco () {
      this.dialogPreco = true
    },
    fakeSalvar () {
      this.$emit('adiciona-produto', this.produto)
      this.closeDialog()
    },
    fechaDialogPreco () {
      this.dialogPreco = false
      this.salvandoPreco = false
      this.preco = {
        uuid_int_id: null,
        prp_acao: null,
        prp_tipo: null,
        prp_valor: null
      }
      if (this.$refs.formProdutoPreco) {
        this.$refs.formProdutoPreco.resetValidation()
      }
    },
    addNovoPreco () {
      if (!this.$refs.formProdutoPreco.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvandoPreco = true
      this.produto.precos.push(this.preco)
      this.atualizaListagemPreco()
      this.fechaDialogPreco()
    },
    listaIntegradoresDisponiveis () {
      if (!this.produto.precos) return this.integradores
      let integradoresAdicionados = this.produto.precos.map(preco => preco.uuid_int_id)
      return this.integradores.filter(integrador => {
        if (!integradoresAdicionados.includes(integrador.value)) return integrador
      })
    },
    atualizaListagemPreco () {
      this.precos = []
      this.produto.precos.map(preco => {
        this.precos.push({
          int_nome: this.encontraNomeIntegrador(preco.uuid_int_id),
          prp_acao: this.modelosPreco[preco.prp_acao - 1].text,
          prp_tipo: this.retornaTipo(preco.prp_tipo),
          prp_valor: this.retornaValor(preco)
        })
      })
    },
    retornaTipo (tipo) {
      if (!tipo) return 'Valor'
      return this.tiposPreco[tipo - 1].text
    },
    retornaValor (preco) {
      if (!preco.prp_tipo || preco.prp_tipo === 2) {
        return this.$root.Formatter.floatToMoney(preco.prp_valor)
      }
      return `${this.$root.Formatter.floatToDouble(preco.prp_valor)}%`
    },
    encontraNomeIntegrador (uuid) {
      let nome = 'Integrador não encontrado'

      this.integradores.map(integrador => {
        if (integrador.value === uuid) {
          nome = integrador.text
        }
      })
      return nome
    },
    abrirDialogExcluirPreco (index) {
      this.indexPrecoExcluir = index
      this.dialogExcluirPreco = true
    },
    cancelarExcluirPreco () {
      this.indexPrecoExcluir = null
      this.dialogExcluirPreco = false
    },
    removerPreco () {
      this.produto.precos.splice(this.indexPrecoExcluir, 1)
      this.precos.splice(this.indexPrecoExcluir, 1)
      this.cancelarExcluirPreco()
    },
    async getTiposEstrutura () {
      this.loading = true
      await Api.get('tipos-estruturas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.tie_nome,
                value: item.uuid_tie_id
              })
            })
            this.tiposEstrutura = info
          } else {
            this.tiposEstrutura = []
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os tipos de estruturas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegrators () {
      Api.get('integradores/integradores-vinculados')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_int_id,
                text: item.int_nome
              })
            })
            this.integradores = info
          }
        })
    },
    async getMarcas () {
      this.loadingMarcas = true
      await Api.get('marcas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.mar_nome,
                value: item.uuid_mar_id
              })
            })
            this.marcas = info
          } else {
            this.marcas = []
          }
          this.loadingMarcas = false
        })
        .catch(err => {
          this.loadingMarcas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as marcas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getModelos () {
      this.loadingModelos = true
      await Api.get('modelos/geral')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.mod_nome,
                value: item.uuid_mod_id
              })
            })
            this.modelos = info
          } else {
            this.modelos = []
          }
          this.loadingModelos = false
        })
        .catch(err => {
          this.loadingModelos = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as modelos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getCategorias () {
      this.loadingCategorias = true
      await Api.get('produtos/categorias')
        .then(res => {
          let info = []
          if (res.data && res.data.length > 0) {
            res.data.map(item => {
              info.push({
                cat_id: item.cat_id,
                uuid_cat_id: item.uuid_cat_id,
                text: item.cat_nome,
                value: item.uuid_cat_id,
                color: item.cat_cor
              })
            })
          }
          this.categorias = info
          this.loadingCategorias = false
        })
        .catch(err => {
          this.loadingCategorias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as categorias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    completaDadosProduto (item) {
      let produtoSelecionado = null

      this.produtosGenericosAll.filter(produto => {
        if (item === produto.uuid_pro_id) produtoSelecionado = produto
      })

      if (!produtoSelecionado) return false
      if (produtoSelecionado.marca) this.produto.uuid_mar_id = produtoSelecionado.marca.uuid_mar_id
      if (produtoSelecionado.modelo) this.produto.uuid_mod_id = produtoSelecionado.modelo.uuid_mod_id
      if (produtoSelecionado.pro_entrada_padrao) this.produto.pro_entrada_padrao = produtoSelecionado.pro_entrada_padrao

      if (produtoSelecionado.modulo) this.produto.modulo = produtoSelecionado.modulo
      if (produtoSelecionado.inversor) this.produto.inversor = produtoSelecionado.inversor
      if (produtoSelecionado.cabo) this.produto.cabo = produtoSelecionado.cabo
      if (produtoSelecionado.stringbox) this.produto.stringbox = produtoSelecionado.stringbox
      if (produtoSelecionado.estrutura) this.produto.estrutura = produtoSelecionado.estrutura
      if (produtoSelecionado.transformador) this.produto.transformador = produtoSelecionado.transformador
    },
    setaCategoria () {
      this.categoriaSelecionada = this.categorias.find(cat => cat.uuid_cat_id === this.produto.uuid_cat_id)
      this.produto.pro_categoria = this.categoriaSelecionada.cat_id
    },
    validaGetGenericos () {
      if (this.$root.Permissions.admin()) return false
      this.getProdutosGenericos()
    },
    async getProdutosGenericos () {
      this.loadingGenericos = true
      await Api.get('produtos/genericos/' + this.produto.uuid_cat_id)
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.pro_nome,
                value: item.uuid_pro_id
              })
            })
            this.produtosGenericosAll = res.data
            this.produtosGenericos = info
            console.log(this.produtosGenericos)
          } else {
            this.produtosGenericosAll = []
            this.produtosGenericos = []
          }
          this.loadingGenericos = false
        })
        .catch(err => {
          this.loadingGenericos = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os produtos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    loadFunctions () {
      this.getTiposEstrutura()
      if (this.$root.Permissions.distributor()) {
        this.getIntegrators()
      }
      this.getCategorias()
      this.getMarcas()
      this.getModelos()
    },
    removeImagem () {
      this.produto.pro_imagem = ''
      this.produto.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    async salvarProduto () {
      if (!this.$refs.formProduto.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'produtos/novo'
      if (this.produto.uuid_pro_id) {
        endpoint = 'produtos/edita'
      }

      let imagemProduto = this.produto.pro_imagem
      this.produto.pro_imagem = null

      await Api.post(endpoint, this.produto)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Produto cadastrado com sucesso!',
            color: 'success'
          })
          if (imagemProduto) {
            this.salvarProdutoImagem(imagemProduto, this.produto)
          }
          this.closeDialog()
          this.$emit('refresh')
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    async salvarProdutoImagem (imagem, produto) {
      const formData = new FormData()
      formData.append(`uuid_pro_id`, produto.uuid_pro_id)
      formData.append(`uuid_cat_id`, produto.uuid_cat_id)
      formData.append(`pro_nome`, produto.pro_nome)
      formData.append(`pro_imagem`, imagem)

      await Api.post('produtos/edita', formData)
        .then((response) => {
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          return true
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.produto_imagem {
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/produtos/ProdutosForm.vue